/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';

function ModalSupplierData({ isOpen, onClose, supplierData, isLoading }) {
  return (
    <Dialog open={isOpen} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography>Dados do Fornecedor na Oracle</Typography>
      </DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box display="flex" justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
            <CircularProgress />
          </Box>
        ) : supplierData && supplierData.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="subtitle2">Nome</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle2">CNPJ</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle2">Vendor ID</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle2">Vendor Site ID</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="subtitle2">Vendor Site Code</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {supplierData.map((supplier, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Typography variant="body2">{supplier.name || '--'}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{supplier.cnpj || '--'}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{supplier.vendorId || '--'}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{supplier.vendorSiteId || '--'}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2">{supplier.vendorSiteCode || '--'}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" style={{ minHeight: '200px' }}>
            <Typography variant="body2">Nenhum dado encontrado</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalSupplierData.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  supplierData: PropTypes.arrayOf(
    PropTypes.shape({
      vendorId: PropTypes.string,
      vendorSiteId: PropTypes.string,
      vendorSiteCode: PropTypes.string,
      name: PropTypes.string,
      cnpj: PropTypes.string,
    }),
  ),
  isLoading: PropTypes.bool,
};

ModalSupplierData.defaultProps = {
  supplierData: [],
  isLoading: false,
};

export default ModalSupplierData;
